import $ from 'jquery'

import colors from '../../../../lib/colors'

import main from './main/main'

export default function(o,parent){

  var div =
    $('<div>')
    .css({
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      height: '34px',
      background: colors.grey.s_900,
      overflow: 'hidden',
      whiteSpace: 'nowrap',
    })

  var mainDiv = main(o,parent)

  var set = function(modelId){
    mainDiv.set(modelId)
  }

  div
  .append(

    mainDiv,

  )

  div.set = set

  return div

}



// WEBPACK FOOTER //
// ./src/client/view/admin/search/tabs/tabs.js